import {useSelector} from 'react-redux';
import {Routes, Route, Navigate} from 'extensions/navigation';
import {MyFiles} from 'interface/layout/MyFiles';
import {Splash} from 'interface/stacks/Splash';
import Folder from 'interface/routes/Folder';
import Login from 'interface/routes/Login';
import * as app from 'store/slices/app';

export function Navigator() {
  const isLoaded = useSelector(app.selectors.isLoaded);
  const isLoggedIn = useSelector(app.selectors.isLoggedIn);

  if (!isLoaded) {
    return <Splash/>;
  }

  const NotFoundRedirect = isLoggedIn
    ? <Navigate to="/folder/myfiles"/>
    : <Navigate to="/login"/>;

  return (
    <Routes>
      <Route path="/folder" element={<MyFiles/>}>
        <Route index element={NotFoundRedirect}/>
        <Route path=":folderKey" element={<Folder/>}/>
        <Route path=":folderKey/:folderName" element={<Folder/>}/>
      </Route>
      <Route path="/login" element={<Login/>}/>
      <Route path="*" element={NotFoundRedirect}/>
    </Routes>
  );
}
